import React from "react";
import Carousel from "./Carousel";

function CollectionsByAffiliate(props) {
  let affiliateCollections = props.collectionsOfAffiliate;
  let currentCollection = getCurrentCollectionIndex(
    props.currentCollection,
    props.collectionsOfAffiliate
  );
  if (!isNaN(currentCollection.index)) {
    affiliateCollections.splice(currentCollection.index, 1);
    affiliateCollections.unshift(currentCollection.collection);
  }
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div>
        {/* <h2>Collections</h2>*/}
        <p>Best of the activities and tours bundled-up for you</p>
      </div>
      <div className="collection-card" style={{ marginTop: "1.2rem" }}>
        <Carousel
          affiliateId={props.affiliateId}
          cards={affiliateCollections}
          numCards={4}
          currentCollectionId={props.currentCollection}
        />
      </div>
    </div>
  );
}
export default CollectionsByAffiliate;

const getCurrentCollectionIndex = (collectionId, collections) => {
  let a = NaN;
  let currentCollection = {};
  collections.forEach((collection, index) => {
    if (collectionId === collection.collection_id) {
      a = index;
      currentCollection = collection;
    }
  });
  return { index: a, collection: currentCollection };
};



// WEBPACK FOOTER //
// ./src/CollectionsByAffiliate.jsx